import React from 'react';
import styled from 'styled-components';

const CGU = () => {
    return (
        <CGUContainer>
            <h1>Conditions Générales d'Utilisation (CGU)</h1>
            <Article>
                <h2>Article 1 – Objet</h2>
                <p>
                    Les présentes CGU définissent les conditions d’utilisation du site Chronofield.fr, permettant aux joueurs du serveur Minecraft Minefield.fr (non affilié) de gérer leurs événements, projets et éléments de roleplay.
                </p>
            </Article>
            <Article>
                <h2>Article 2 – Accès et inscription</h2>
                <p>
                    L’accès au site est réservé aux joueurs du serveur. L’inscription nécessite un pseudo, une adresse mail valide et un mot de passe. Les identifiants sont personnels et confidentiels.
                </p>
            </Article>
            <Article>
                <h2>Article 3 – Utilisation du site</h2>
                <p>
                    L’utilisateur s’engage à respecter la finalité du site et à ne pas nuire à son fonctionnement ou à la sécurité des autres utilisateurs.
                </p>
            </Article>
            <Article>
                <h2>Article 4 – Données personnelles</h2>
                <p>
                    Les données collectées (pseudo, mail, mot de passe, événements, projets) sont traitées conformément au RGPD. L’utilisateur peut à tout moment accéder, rectifier ou supprimer ses données.
                </p>
            </Article>
            <Article>
                <h2>Article 5 – Propriété intellectuelle</h2>
                <p>
                    Les contenus du site sont protégés. Les contributions des utilisateurs restent leur propriété, mais une licence d’utilisation est accordée au site.
                </p>
            </Article>
            <Article>
                <h2>Article 6 – Responsabilité</h2>
                <p>
                    L’utilisateur est responsable de l’usage de son compte. L’éditeur n’est pas responsable des dysfonctionnements indépendants de sa volonté.
                </p>
            </Article>
            <Article>
                <h2>Article 7 – Modification des CGU</h2>
                <p>
                    Les présentes CGU peuvent être modifiées à tout moment. Les utilisateurs seront informés des changements.
                </p>
            </Article>
            <Article>
                <h2>Article 8 – Loi applicable et litiges</h2>
                <p>
                    Les CGU sont régies par la loi française. 
                </p>
            </Article>
            <Article>
                <h2>Article 9 – Contact</h2>
                <p>
                    Pour toute question, le Discord du serveur reste le canal adapté.
                </p>
            </Article>
        </CGUContainer>
    );
};

export default CGU;

const CGUContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start; // or use padding-top for more control
    min-height: 70vh; // Use min-height for better handling of long content
    margin: 0 auto;
    max-width: 800px; for better readability
    padding-top: 5vh; // Adjust this value for vertical offset
    padding-bottom: 5vh; // to avoid footer overlap
`;

const Article = styled.section`
    width: 100%;
    margin-bottom: 20px;
    text-align: left;
`;
